<template>
  <div id='nav-bar' :style="{ 'background-color': backgroundColor, height:  this.$route.params.NavBarHeight + 'px'}">
    <div class="content">
      <img class="backIcon" src="~@/assets/backIcon.png" @click="goBack"/>
      <div class="title" v-html="title"></div>
      <component :is='rightButton'/>
    </div>
  </div>
</template>

<script>
import { goLastModule } from '@/router'

export default {
  name: 'nav-bar',
  data () {
    return {
      title: '',
      transChild: false,
      rightButton: null
    }
  },
  mounted () {
    this.$emit('transChild', this.transChild)
  },
  watch: {
    transChild (newValue, oldValue) {
      this.$emit('transChild', newValue)
    }
  },
  computed: {
    backgroundColor () {
      return this.transChild ? 'transparent' : '#06b782'
    }
  },
  methods: {
    goBack () {
      goLastModule()
    }
  }
}
</script>

<style lang="sass" scoped>
@import '@/styles'
#nav-bar
  padding: 0 15px
  z-index: 6000
  position: sticky
  top: 0
  background-color: #06b782
  .content
    width: 100%
    height: 100%
    display: flex
    align-items: center
    text-align: center
    position: relative
    .backIcon
      width: 22px
      height: 22px
      position: absolute
      bottom: 13px
      z-index: 1

    .title
      width: calc( 100% - 120px )
      font-size: 20px
      color: white
      position: absolute
      left: 60px
      bottom: 13px
      font-family: PingFangSC-Regular, sans-serif
      overflow: hidden
      white-space: nowrap
      text-overflow: ellipsis
      word-break: keep-all
</style>
